export const getQuestions = (translations, props) => [
  {
    id: "GENDER",
    code: "GENDER",
    type: "multiple",
    title: translations.questionGenderTitle,
    description: translations.questionGenderDescription,
    answers: [
      {
        value: "MALE",
        img: props.maleImage,
        tag: translations.questionGenderMale,
      },
      {
        value: "FEMALE",
        img: props.femaleImage,
        tag: translations.questionGenderFemale,
      },
    ],
  },
  {
    id: "VOICE_TONE_LEVEL",
    type: "multiple",
    code: "VOICE_TONE_LEVEL",
    title: translations.questionVoiceTitle,
    description: translations.questionVoiceDescription,
    answers: [
      {
        value: "BASS",
        img: props.voiceLowImage,
        tag: translations.questionVoiceLow,
      },
      {
        value: "NORMAL",
        img: props.voiceMediumImage,
        tag: translations.questionVoiceMedium,
      },
      {
        value: "HIGH",
        img: props.voiceHighImage,
        tag: translations.questionVoiceHigh,
      },
    ],
  },
  {
    id: "LANGUAGE",
    code: "LANGUAGE",
    type: "dropdown",
    title: translations.questionLanguageTitle,
    label: translations.questionLanguageLabel,
    placeholder: translations.selectOptionPlaceholder,
    optionKey: "language",
    valueTemplateKey: "selectedLanguageTemplate",
    itemTemplateKey: "languageTemplate",
  },
  {
    id: "PERSONALITY",
    type: "multiple",
    code: "PERSONALITY",
    title: translations.questionPersonalityTitle,
    description: translations.questionPersonalityDescription,
    answers: [
      {
        value: "BRIGHT_AND_ENERGETIC",
        img: props.personalEnergeticImage,
        tag: translations.questionPersonalityEnergetic,
      },
      {
        value: "KIND_AND_PATIENT",
        img: props.personalKindImage,
        tag: translations.questionPersonalityKind,
      },
      {
        value: "GENTLE_AND_CALM",
        img: props.personalCalmImage,
        tag: translations.questionPersonalityCalm,
      },
      {
        value: "SERIOUS_AND_HELPS_IMPROVE_CONCENTRATION",
        img: props.personalSeriousImage,
        tag: translations.questionPersonalitySerious,
      },
      {
        value: "FUN_AND_HUMOROUS",
        img: props.personalFunnyImage,
        tag: translations.questionPersonalityFunny,
      },
      {
        value: "HIGHLY_EMPATHETIC_AND_WARM",
        img: props.personalEmpatheticImage,
        tag: translations.questionPersonalityEmpathetic,
      },
    ],
  },
  {
    id: "COMMUNICATION_STYLE",
    type: "multiple",
    code: "COMMUNICATION_STYLE",
    title: translations.questionCommunicationStyleTitle,
    description: translations.questionCommunicationStyleDescription,
    answers: [
      {
        value: "INTERACTIVE_WITH_LOTS_OF_QUESTIONS",
        img: props.communicationStyleDialogueManyQuestionsImage,
        tag: translations.questionCommunicationStyleDialogueManyQuestions,
      },
      {
        value: "SLOW_PACED_EASY_TO_UNDERSTAND_EXPLANATION_FOCUSED",
        img: props.communicationStyleEasyDeliveryFocusedImage,
        tag: translations.questionCommunicationStyleEasyDeliveryFocused,
      },
      {
        value: "IMMEDIATE_FEEDBACK",
        img: props.communicationStyleImmediateFeedbackImage,
        tag: translations.questionCommunicationStyleImmediateFeedback,
      },
      {
        value: "INTERACTIVE",
        img: props.communicationStyleFreeDialogueImage,
        tag: translations.questionCommunicationStyleFreeDialogue,
      },
      {
        value: "DISCUSSION_BASED",
        img: props.communicationStyleDiscussionTypeImage,
        tag: translations.questionCommunicationStyleDiscussionType,
      },
    ],
  },
  {
    id: "LECTURE_TYPE",
    type: "multiple",
    code: "LECTURE_TYPE",
    title: translations.questionLectureTypeTitle,
    description: translations.questionLectureTypeDescription,
    answers: [
      {
        value: "CONVERSATION_FOCUSED",
        img: props.lectureTypeQuestionCenteredImage,
        tag: translations.lectureTypeQuestionCentered,
      },
      {
        value: "GRAMMAR_AND_THEORY_FOCUSED",
        img: props.lectureTypeGrammarTheoryCenteredImage,
        tag: translations.lectureTypeGrammarTheoryCentered,
      },
      {
        value: "REAL_LIFE_APPLICATION",
        img: props.lectureTypeRealLifeApplicationImage,
        tag: translations.lectureTypeRealLifeApplication,
      },
      {
        value: "ASSIGNMENT_AND_REVIEW_FOCUSED",
        img: props.lectureTypeAssignmentLearningCenteredImage,
        tag: translations.lectureTypeAssignmentLearningCentered,
      },
      {
        value: "FREE_TOPIC_DISCUSSION",
        img: props.lectureTypeFreeTopicDiscussionImage,
        tag: translations.lectureTypeFreeTopicDiscussion,
      },
    ],
  },
  {
    id: "LECTURE_MATERIALS",
    type: "multiple",
    code: "LECTURE_MATERIALS",
    title: translations.questionLectureMaterialTitle,
    description: translations.questionLectureMaterialDescription,
    answers: [
      {
        value: "PPT",
        img: props.lectureMaterialPPTImage,
        tag: translations.lectureMaterialPPT,
      },
      {
        value: "VOCABULARY_CARDS_AND_TEXTBOOKS",
        img: props.lectureMaterialWordCardsTextbooksImage,
        tag: translations.lectureMaterialWordCardsTextbooks,
      },
      {
        value: "WEB_CONTENT",
        img: props.lectureMaterialWebOnlineContentImage,
        tag: translations.lectureMaterialWebOnlineContent,
      },
      {
        value: "NOTEBOOKS_AND_NOTES",
        img: props.lectureMaterialNotesHandwrittenImage,
        tag: translations.lectureMaterialNotesHandwritten,
      },
      {
        value: "VIDEO_MATERIALS",
        img: props.lectureMaterialVideoImage,
        tag: translations.lectureMaterialVideo,
      },
    ],
  },
]; 